import script from "./CustomBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./CustomBreadcrumb.vue?vue&type=style&index=0&id=47610614&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47610614"]])

export default __exports__